'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UIAvatarMultiOrSingle = require('./UIAvatarMultiOrSingle');

var _UIAvatarMultiOrSingle2 = _interopRequireDefault(_UIAvatarMultiOrSingle);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _Constants = require('./Constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var avatarSizeBackwardsCompat = {
  'extra-small': 'xs',
  small: 'sm',
  medium: 'md',
  large: 'lg',
  'extra-large': 'xl'
};

// This file is now just going to absorbe the API changes from v1 to
// v2 so we can be waaaay cleaner down the line

var UIAvatar = function (_Component) {
  _inherits(UIAvatar, _Component);

  function UIAvatar() {
    _classCallCheck(this, UIAvatar);

    return _possibleConstructorReturn(this, (UIAvatar.__proto__ || Object.getPrototypeOf(UIAvatar)).apply(this, arguments));
  }

  _createClass(UIAvatar, [{
    key: 'companyWithWarning',
    value: function companyWithWarning(company) {
      if (company) {
        _devLogger2.default.warn({
          message: 'there is no company prop, maybe you mean domain or companyId'
        });
      }
    }
  }, {
    key: 'sizeWithWarning',
    value: function sizeWithWarning(size) {
      var checkedAvatarSize = avatarSizeBackwardsCompat[size];
      if (checkedAvatarSize) {
        _devLogger2.default.warn({
          message: 'Old size prop values are supplied, please use 2 letter sizes instead'
        });
        return checkedAvatarSize;
      }

      return size;
    }
  }, {
    key: 'lookupWithWarning',
    value: function lookupWithWarning(lookup, lookups, avatarLookup) {
      var oldLookup = lookups || avatarLookup;

      if (oldLookup) {
        _devLogger2.default.warn({
          message: 'lookups and avatarLook up are depreciated props, please just use lookup'
        });

        return lookup || oldLookup;
      }
      return lookup;
    }
  }, {
    key: 'hubSpotUserEmailWithWarning',
    value: function hubSpotUserEmailWithWarning(hubSpotUserEmail, hubspotUserEmail) {
      if (hubspotUserEmail) {
        _devLogger2.default.warn({
          message: 'I think you meant hubSpotUserEmail (S vs s)'
        });
      }
      return hubSpotUserEmail || hubspotUserEmail;
    }
  }, {
    key: 'maxAvatarsWithWarning',
    value: function maxAvatarsWithWarning(maxAvatars, totalNumOfAvatars) {
      if (totalNumOfAvatars) {
        _devLogger2.default.warn({
          message: 'totalNumOfAvatars is depreciated, please use maxAvatars instead'
        });
        return maxAvatars || totalNumOfAvatars;
      }

      return maxAvatars;
    }
  }, {
    key: 'catchWeirdProps',
    value: function catchWeirdProps() {
      var _props = this.props,
          _isHoverlayOpen = _props._isHoverlayOpen,
          _toolTipOverWrite = _props._toolTipOverWrite,
          authed = _props.authed,
          avatarLookup = _props.avatarLookup,
          avatarType = _props.avatarType,
          childClassName = _props.childClassName,
          children = _props.children,
          childStyles = _props.childStyles,
          className = _props.className,
          companyId = _props.companyId,
          displayName = _props.displayName,
          company = _props.company,
          domain = _props.domain,
          email = _props.email,
          existsInPortal = _props.existsInPortal,
          fetchAvatars = _props.fetchAvatars,
          fileManagerKey = _props.fileManagerKey,
          hasMoreHref = _props.hasMoreHref,
          href = _props.href,
          hubspotUserEmail = _props.hubspotUserEmail,
          hubSpotUserEmail = _props.hubSpotUserEmail,
          isHoverlay = _props.isHoverlay,
          lookup = _props.lookup,
          lookups = _props.lookups,
          maxAvatars = _props.maxAvatars,
          portalId = _props.portalId,
          size = _props.size,
          socialNetwork = _props.socialNetwork,
          src = _props.src,
          style = _props.style,
          totalNumOfAvatars = _props.totalNumOfAvatars,
          type = _props.type,
          textSpacing = _props.textSpacing,
          truncateLength = _props.truncateLength,
          vid = _props.vid;

      // avatarRenderer
      // backgroundcolor
      // color
      // name …only social is using UIAvatarIcon and that's depreciated now.
      // https://private.hubteamqa.com/opengrok/search?q=%22%3CUIAvatarIcon%22&defs=&refs=&path=&hist=&type=&project=all
      // Shape

      // Warnings
      // size needs to be
      // lookups
      // avatarLookup

      return {
        _isHoverlayOpen: _isHoverlayOpen,
        _toolTipOverWrite: _toolTipOverWrite,
        authed: authed,
        childClassName: childClassName,
        children: children,
        childStyles: childStyles,
        className: className,
        company: this.companyWithWarning(company),
        companyId: companyId,
        displayName: displayName,
        domain: domain,
        email: email,
        existsInPortal: existsInPortal,
        fetchAvatars: fetchAvatars,
        fileManagerKey: fileManagerKey,
        hasMoreHref: hasMoreHref,
        href: href,
        hubSpotUserEmail: this.hubSpotUserEmailWithWarning(hubSpotUserEmail, hubspotUserEmail),
        isHoverlay: isHoverlay,
        lookup: this.lookupWithWarning(lookup, lookups, avatarLookup),
        maxAvatars: maxAvatars || totalNumOfAvatars,
        portalId: portalId,
        size: this.sizeWithWarning(size),
        socialNetwork: socialNetwork,
        src: src,
        style: style,
        type: type || avatarType,
        textSpacing: textSpacing,
        truncateLength: truncateLength,
        vid: vid
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_UIAvatarMultiOrSingle2.default, this.catchWeirdProps(this.props));
    }
  }]);

  return UIAvatar;
}(_react.Component);

UIAvatar.propTypes = {
  lookups: _react.PropTypes.any,
  avatarLookup: _react.PropTypes.any,
  totalNumOfAvatars: _react.PropTypes.number,
  avatarType: _react.PropTypes.string,

  _isHoverlayOpen: _react.PropTypes.bool,
  _toolTipOverWrite: _react.PropTypes.bool,
  authed: _react.PropTypes.bool,
  childClassName: _react.PropTypes.string,
  children: _react.PropTypes.node,
  childStyles: _react.PropTypes.object,
  className: _react.PropTypes.string,
  company: _react.PropTypes.string,
  companyId: _react.PropTypes.number,
  displayName: _react.PropTypes.string,
  domain: _react.PropTypes.string,
  email: _react.PropTypes.string,
  existsInPortal: _react.PropTypes.bool,
  fetchAvatars: _react.PropTypes.func,
  fileManagerKey: _react.PropTypes.string,
  hasMoreHref: _react.PropTypes.string,
  href: _react.PropTypes.string,
  hubspotUserEmail: _react.PropTypes.string,
  hubSpotUserEmail: _react.PropTypes.string,
  isHoverlay: _react.PropTypes.bool,
  lookup: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.array]),
  maxAvatars: _react.PropTypes.number,
  portalId: _react.PropTypes.number,
  size: _react.PropTypes.oneOf(Object.keys(_Constants.AVATAR_SIZES)),
  socialNetwork: _react.PropTypes.string,
  src: _react.PropTypes.string,
  style: _react.PropTypes.object,
  type: _react.PropTypes.string,
  textSpacing: _react.PropTypes.number,
  truncateLength: _react.PropTypes.number,
  vid: _react.PropTypes.number
};
exports.default = UIAvatar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.493/js/UIAvatar.js
// module id = 482
// module chunks = 2 3